<!-- version 2021/05/20 -->
<template>
    <a class="btn" :href="link" role="button">
      <i :class="fa"></i>
      {{ title }}
    </a>
</template>

<script>
    export default {
        props: {
            title: String,
            link: String,
            fa: String
        }
    }
</script>

<style lang="sass" scoped>
    a
        border-radius: 6px !important
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) !important
        background-color: #28c3cd !important
        color: #FFF !important
</style>
